var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272.775,
    height: 38.024,
    viewBox: "0 0 272.775 38.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 272.775,
    height: 38.024,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M19.283,1.381,7.856,14.284,6.808,15.617,7,13.856V1.381H0V36.424H7V23.188l1.715-1.715L19.521,36.424h8.761L13.759,17.093,28.234,1.381Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M48.4,15.217l3.366,8.543H44.84ZM48.566,0,32.757,36.425h6.81l2.855-6.856H54.053l2.7,6.856h8L48.947,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M83.657,1.381a16.745,16.745,0,0,1,7.332,1.452,10.472,10.472,0,0,1,4.571,4.1,12.032,12.032,0,0,1,1.571,6.261,15.106,15.106,0,0,1-.643,4.309,11.458,11.458,0,0,1-2.047,3.928,9.994,9.994,0,0,1-3.762,2.834,13.951,13.951,0,0,1-5.785,1.071H79.942V36.425h-6.9V1.381Zm1.189,17.236a5.621,5.621,0,0,0,2.62-.547,4.572,4.572,0,0,0,1.642-1.381,6.05,6.05,0,0,0,1.119-3.309,8.009,8.009,0,0,0-.167-1.4,5.692,5.692,0,0,0-.69-1.786,4.242,4.242,0,0,0-1.6-1.523,5.755,5.755,0,0,0-2.881-.619H79.942v10.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M156.551,37.853l-26.568-24L132.03,15l.142,21.427h-7V0h.285l26,23.9-1.524-.666L149.79,1.381h6.952V37.853Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M168.979,36.425V1.381h10.475a23.059,23.059,0,0,1,9,1.572,15.923,15.923,0,0,1,5.975,4.19A16.8,16.8,0,0,1,197.738,13a21.119,21.119,0,0,1,1.047,6.523,16.919,16.919,0,0,1-1.4,7.023,16.046,16.046,0,0,1-3.833,5.333,16.82,16.82,0,0,1-5.619,3.38,19.5,19.5,0,0,1-6.761,1.167Zm6.9-6.666h4.094a15.45,15.45,0,0,0,4.762-.69,10.512,10.512,0,0,0,3.69-2.024,8.737,8.737,0,0,0,2.381-3.356,12.123,12.123,0,0,0,.833-4.643,12.189,12.189,0,0,0-1.118-5.594,9.357,9.357,0,0,0-2.762-3.357,10.17,10.17,0,0,0-3.357-1.643A11.748,11.748,0,0,0,181.5,8h-5.618Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M219.5,1.381a19,19,0,0,1,5.857.833,11.926,11.926,0,0,1,4.309,2.38A10.161,10.161,0,0,1,232.3,8.308a12.563,12.563,0,0,1,.905,4.881,14.864,14.864,0,0,1-.643,4.285,11.124,11.124,0,0,1-2.1,3.9,10.378,10.378,0,0,1-3.833,2.833,14.387,14.387,0,0,1-5.9,1.072h-4.952V36.424h-6.9V1.381Zm1.19,17.236a5.838,5.838,0,0,0,2.62-.524,4.464,4.464,0,0,0,1.641-1.333,5.489,5.489,0,0,0,.858-1.69,5.808,5.808,0,0,0,.261-1.643,8.12,8.12,0,0,0-.166-1.452,5.716,5.716,0,0,0-.69-1.786,4.242,4.242,0,0,0-1.6-1.523,5.76,5.76,0,0,0-2.881-.619h-4.952v10.57Zm6.476,4.285,8.665,13.522h-8.046l-8.856-13.331Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M240.779,36.425,256.586,0h.382l15.807,36.425h-8l-10.1-25.616,5-3.428L247.587,36.425ZM251.587,23.76h10.522l2.428,5.809H249.444Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M118.48,10.424a7.788,7.788,0,0,0-6.526-7.708,2.138,2.138,0,0,0-.808-.32.921.921,0,1,0-.829.009,2.69,2.69,0,0,0-.833.3,7.788,7.788,0,0,0-6.575,7.666,7.518,7.518,0,0,0,6.829,7.782l-.05,15.506a2.1,2.1,0,0,0-.838,1.776,2.355,2.355,0,0,0,1.144,1.782v.188a.614.614,0,1,0,1.228,0v-.188a2.443,2.443,0,0,0,1.184-1.807,2.1,2.1,0,0,0-.827-1.781l.05-15.506a7.464,7.464,0,0,0,6.85-7.706",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.10ee7da62e4857cd6cf3a64fcadf3ee7.svg";
export { ForwardRef as ReactComponent };